<template>
    <div class="row">
        <div class="col-3">
            <div class="card">
                <div class="card-header hoursSubHeader">
                    Total Hours
                </div>
                <div class="card-body">
                    <h6 class="card-title hoursTotals">{{totalHours.toFixed(2)}}</h6>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card">
                <div class="card-header hoursSubHeader">
                    Regular Hours
                </div>
                <div class="card-body">
                    <h6 class="card-title hoursTotals">{{regularHours.toFixed(2)}}</h6>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card">
                <div class="card-header hoursSubHeader">
                    OT Hours
                </div>
                <div class="card-body">
                    <h6 class="card-title hoursTotals">{{otHours.toFixed(2)}}</h6>
                </div>
            </div>
        </div>
        <div v-if="travelHours > 0" class="col-3">
            <div class="card">
                <div class="card-header hoursSubHeader">
                    Travel Time
                </div>
                <div class="card-body">
                    <h6 class="card-title hoursTotals">{{travelHours.toFixed(2)}}</h6>
                </div>
            </div>
        </div>
        <div v-if="onCallHours > 0" class="col-3">
            <div class="card">
                <div class="card-header hoursSubHeader">
                    On Call Hours
                </div>
                <div class="card-body">
                    <h6 class="card-title hoursTotals">{{onCallHours.toFixed(2)}}</h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'timeCardTotals',
    computed: {
        ...mapState(['totalHours', 'regularHours', 'otHours', 'travelHours', 'onCallHours']),
        totalCardCount: function(){
            //check to see if the stat, travel, or on call have hours. If they do, then count them.
            let count = 3;
            if(this.travelHours > 0){
                count++;
            }
            if(this.onCallHours){
                count++;
            }
            return count;
        }
    }
}
</script>